module.exports = __webpack_public_path__ + "img/mike_gesicki.058aad0f.png";